import {useEffect, useState} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {listMessage, listTopic} from '../../../../app/modules/auth/core/_requests'
import {AxiosError} from 'axios'
import './senseMinerHeader.css'
import {useLang} from '../../../i18n/Metronici18n'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import Message from './Message'
import {useSelectDeviceId2} from '../../../layout/core'

function SenseMiner() {
  const lang = useLang()
  const intl = useIntl()
  const [message, setMessage] = useState([])
  const [checkboxValues, setCheckboxValues] = useState(false)
  const [deviceID2, setDeviceID2] = useState(0)
  const [topicMenuCategory, setTopicMenuCategory] = useState([])
  const [selectedTopic, setSelectedTopic] = useState<any>(null)
  const {SelectDeviceId2, setSelectDeviceId2} = useSelectDeviceId2()

  // Topic Menu Verisi İçin Kullanıyoruz
  const getTopicList = async () => {
    try {
      const {data} = await listTopic(0)
      setTopicMenuCategory(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      setTopicMenuCategory([])
      console.error(error)
    }
  }
  useEffect(() => {
    getTopicList()
  }, [])

  useEffect(() => {
    if (checkboxValues) {
      setCheckboxValues(false)
    }
    getMessage()
  }, [selectedTopic?.id])

  useEffect(() => {
    setDeviceID2(getDeviceId())
  }, [window.localStorage.getItem('selectDevice2'), SelectDeviceId2])

  const getDeviceId = () => {
    let localSelectDevice2 = window.localStorage.getItem('selectDevice2')
    return localSelectDevice2
      ? JSON.parse(localSelectDevice2)
        ? JSON.parse(localSelectDevice2)[0]
        : 0
      : 0
  }

  const UnsuccessfulNotify = (message: string) =>
    toast.error(`${message}`, {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    })

  // Seçili Topic Verisi İçin Kullanıyoruz.
  const getMessage = async () => {
    if (deviceID2) {
      try {
        const {data} = await listMessage(0, selectedTopic.id, Number(deviceID2))
        setMessage(data)
      } catch (err) {
        const error = `${(err as AxiosError)?.response?.data}`
        setMessage([])
        console.error(error)
      }
    }
  }

  // Start Topic Listen
  function handleCheckboxChange() {
    if (deviceID2) {
      setCheckboxValues((prevValues: any) => !prevValues)
    } else {
      UnsuccessfulNotify(intl.formatMessage({id: 'DEVICE.SELECTION'}))
    }
  }

  useEffect(() => {
    if (checkboxValues) {
      const intervalId = setInterval(() => {
        getMessage()
      }, 2000)
      return () => clearInterval(intervalId)
    }
  }, [checkboxValues])
  // End Topic Listen

  //Read Butonuna Basıldığında Okuma Yapması İçin
  function handleReadValue() {
    if (deviceID2) {
      getMessage()
    } else {
      UnsuccessfulNotify(intl.formatMessage({id: 'DEVICE.SELECTION'}))
    }
  }

  return (
    <div
      id='kt_senseminer'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='senseminer'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'100%', 'lg': '900px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_senseminer_toggle'
      data-kt-drawer-close='#kt_senseminer_close'
    >
      <div className='card shadow-none rounded-0' style={{width: '100%'}}>
        <div className='card-header' id='kt_senseminer_header'>
          <h3 className='card-title fw-bolder text-dark'>Sense Miner</h3>

          <div className='card-toolbar'>
            <button
              type='button'
              className='btn btn-sm btn-icon btn-active-light-primary me-n5'
              id='kt_senseminer_close'
            >
              <KTIcon iconName='cross' className='fs-2qx' />
            </button>
          </div>
        </div>
        {/* Sense Miner Category List */}
        <div
          className='card-header mt-5 pe-5'
          style={{minHeight: '200px !important'}}
          id='kt_senseminer_sensorHeader'
        >
          <ul
            className='nav nav-pills nav-pills-custom mb-3 d-flex justify-content-between w-100'
            role='tablist'
          >
            {/* List of sensor tabs */}
            {topicMenuCategory.map((item: any, index) => {
              return (
                <li key={index} className='nav-item mb-3' role='presentation'>
                  <a
                    className='sensor_link nav-link btn btn-outline btn-flex btn-color-muted btn-active-primary  flex-column overflow-hidden w-50px w-xl-80px h-50px h-xl-85px pt-4 pt-xl-5 pb-2'
                    id='sensor_tab_link_1'
                    data-bs-toggle='pill'
                    href='#sensor_tab_1'
                    aria-selected='true'
                    role='tab'
                    onClick={() => setSelectedTopic(item)}
                  >
                    <div className='nav-icon mb-3'>
                      <img
                        src={toAbsoluteUrl(
                          `/media/icons/senseminer/${item.name.toLowerCase()}.png`
                        )}
                        className='w-35px w-xl-25px'
                        alt='Humidity'
                      />
                    </div>
                    <span
                      className={`sensor_name fw-bold fs-9 lh-1 d-none d-sm-inline ${
                        selectedTopic === item && 'text-white'
                      }`}
                    >
                      {item.name}
                    </span>
                  </a>
                </li>
              )
            })}
          </ul>
          {/* Checkboxes and Read button */}
          <div className='d-flex align-items-center justify-content-start my-5'>
            <div className='d-flex align-items-center form-check form-check-success form-check-solid me-4'>
              <div className='form-check'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  name={`flexCheckBoxListen`}
                  id={`flexCheckBoxListen`}
                  checked={checkboxValues}
                  onChange={() => handleCheckboxChange()}
                />

                <label className='form-check-label ms-1' htmlFor={`flexCheckBoxListen`}>
                  {lang === 'tr' ? 'Sürekli' : 'Continuously'}
                </label>
              </div>
            </div>
            <div>
              <button
                type='button'
                className='btn btn-success mr-2'
                onClick={() => handleReadValue()}
              >
                {lang === 'tr' ? 'Oku' : 'Read'}
              </button>
            </div>
          </div>
        </div>
        {/* Sense Miner Category List */}

        <div className='card-body position-relative' id='kt_senseminer_body'>
          <div
            id='kt_senseminer_scroll'
            className='position-relative scroll-y me-n5 '
            data-kt-scroll='true'
            data-kt-scroll-height='auto'
            data-kt-scroll-wrappers='#kt_senseminer_body'
            data-kt-scroll-dependencies='#kt_senseminer_header, #kt_senseminer_footer, #kt_senseminer_sensorHeader'
            data-kt-scroll-offset='5px'
          >
            {selectedTopic && (
              <Message
                message={message}
                measurementUnit={topicMenuCategory?.filter((i: any) => i.id === selectedTopic?.id)}
                title={selectedTopic?.name}
              />
            )}
          </div>
        </div>
        <div className='card-footer py-5 text-center' id='kt_senseminer_footer'>
          <span className='fs-3 fw-bold text-primary '>
            {selectedTopic?.name} - {selectedTopic?.description}
          </span>
        </div>
      </div>
    </div>
  )
}

export {SenseMiner}
